import { AnyAction, Dispatch } from "redux";
import { action } from "typesafe-actions";
import { ILeadsData } from "./leadsData.types";
import { ThunkAction } from "redux-thunk";
import { IStoreState } from "../initialStoreState";
import { IDate } from "../../components/Table/hooks/useDateFilter";
import { api } from "../../api/api";
import {
    closeLoaderWithMessage,
    openLoaderWithMessage,
    showMessage,
} from "../messages/messagesActions";

// List actions
export const FETCH_LEADS_DATA_PROGRESS = "FETCH_LEADS_DATA_PROGRESS";
export const FETCH_LEADS_DATA_SUCCESS = "FETCH_LEADS_DATA_SUCCESS";
export const FETCH_LEADS_DATA_FAILURE = "FETCH_LEADS_DATA_FAILURE";

export const fetchLeadsDataProgress = () => action(FETCH_LEADS_DATA_PROGRESS);

export const fetchLeadsDataSuccess = (
    data: ILeadsData[],
    totalRecords: number
) => action(FETCH_LEADS_DATA_SUCCESS, { data, totalRecords });

export const fetchLeadsDataFailure = (error: string) =>
    action(FETCH_LEADS_DATA_FAILURE, error);

export const fetchLeadsDataAsync =
    (
        forReport: boolean = false,
        date: IDate,
        searchType?: string,
        searchValue?: string,
        pageNumber?: number,
        rowsInPerPage?: number,
    ): ThunkAction<Promise<ILeadsData[] | void>, IStoreState, {}, AnyAction> =>
    async (dispatch) => {
        try {
            dispatch(fetchLeadsDataProgress());
            let url = ""

            if(searchType && searchValue){
                url += `${searchType}=${searchValue}&`
            }
            if(forReport === false){
                url += `pageNo=${pageNumber}&itemsPerPage=${rowsInPerPage}&`
            }
            const finalUrl = `get-uploaded-csv-file-stored-data-in-lead-data-table?from_date=${date.fromDate}&to_date=${date.toDate}&${url}`;
            const res = await api.get(finalUrl);
            const data: ILeadsData[] = res.data.result;
            const totalRecords = res.data.totalRecords;

            if (forReport) {
                return data;
            }

            dispatch(
                showMessage({
                    message: "Leads Data fetched successfully",
                    type: "success",
                    displayAs: "snackbar",
                })
            );
            dispatch(fetchLeadsDataSuccess(data, totalRecords));
        } catch (error: any) {
            dispatch(fetchLeadsDataFailure(error.message));
            dispatch(
                showMessage({
                    message: error.response.data.message,
                    type: "error",
                    displayAs: "snackbar",
                })
            );
        }
    };

// Single record actions
export const FETCH_SINGLE_LEADS_DATA_PROGRESS = "FETCH_SINGLE_LEADS_DATA_PROGRESS";
export const FETCH_SINGLE_LEADS_DATA_SUCCESS = "FETCH_SINGLE_LEADS_DATA_SUCCESS";
export const FETCH_SINGLE_LEADS_DATA_FAILURE = "FETCH_SINGLE_LEADS_DATA_FAILURE";

export const fetchSingleLeadsDataProgress = () =>
    action(FETCH_SINGLE_LEADS_DATA_PROGRESS);

export const fetchSingleLeadsDataSuccess = (data: ILeadsData) =>
    action(FETCH_SINGLE_LEADS_DATA_SUCCESS, data);

export const fetchSingleLeadsDataFailure = (error: string) =>
    action(FETCH_SINGLE_LEADS_DATA_FAILURE, error);

export const fetchSingleLeadsDataAsync =
    (id: string): ThunkAction<void, IStoreState, {}, AnyAction> =>
    async (dispatch) => {
        try {
            dispatch(fetchSingleLeadsDataProgress());
            const res = await api.get(`get-uploaded-csv-file-stored-data-in-lead-data-table/${id}`);
            const data: ILeadsData = res.data.result;
            dispatch(
                showMessage({
                    message: "Lead Data fetched successfully",
                    type: "success",
                    displayAs: "snackbar",
                })
            );
            dispatch(fetchSingleLeadsDataSuccess(data));
        } catch (error: any) {
            dispatch(fetchSingleLeadsDataFailure(error.message));
            dispatch(
                showMessage({
                    message: error.response.data.message,
                    type: "error",
                    displayAs: "snackbar",
                })
            );
        }
    };

export const CLEAR_LEADS_DATA = "CLEAR_LEADS_DATA";
export const CLEAR_LEADS_DATA_STATE = "CLEAR_LEADS_DATA_STATE";
export const clearLeadsData = () => action(CLEAR_LEADS_DATA);
export const clearLeadsDataState = () => action(CLEAR_LEADS_DATA_STATE);
